import { render, staticRenderFns } from "./IncreaseStockForm.vue?vue&type=template&id=680e66fe"
import script from "./IncreaseStockForm.vue?vue&type=script&lang=js"
export * from "./IncreaseStockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports